module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution_one.4cbcf7dd.png";